<div fxFlex fxLayout="column">
  <div fxFlex fxLayout="column" class="table-content">
    <table mat-table
      #toursTable
      matSort
      [ngClass]="(isSidebarExpanded$ | async) ? '' : 'expanded'"
      [dataSource]="dataSource"
      class="clickable-items-table"
      >
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="tour-type">{{ 'tours.type' | translate }}</th>
        <td mat-cell *matCellDef="let tour" class="tour-type">
          <div class="tour-type-box" [title]="tour.tourType">
            {{ tour.tourType.substring(0, 1) }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="costCenter">
        <th mat-header-cell mat-sort-header="costCenter" *matHeaderCellDef>{{ 'core.costCenter' | translate }}</th>
        <td mat-cell *matCellDef="let tour"
          [class.location-colored]="mode === viewMode.MonthOverview && tour.location?.color"
          [style.border-left-color]="mode === viewMode.MonthOverview ? tour.location?.color : null"
          [matTooltip]="mode === viewMode.MonthOverview ? tour.location?.name : ''"
          matTooltipPosition="above"
        >{{ tour.constructionSite?.costcenter }}</td>
      </ng-container>
      <ng-container matColumnDef="constructionSite">
        <th mat-header-cell mat-sort-header="tour.constructionSite.name" *matHeaderCellDef>{{ 'core.constructionSite' | translate }}</th>
        <td mat-cell *matCellDef="let tour" [matTooltip]="tour.constructionSite.name"  matTooltipPosition="above">
          {{ tour.constructionSite.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customer">
        <th mat-header-cell mat-sort-header="tour.customer.code" *matHeaderCellDef >{{ 'core.customer' | translate }}</th>
        <td mat-cell *matCellDef="let tour" [matTooltip]="tour.customer.code"  matTooltipPosition="above">
          {{ tour.customer.code }}
        </td>
      </ng-container>
      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.remarks' | translate }}</th>
        <td
          mat-cell *matCellDef="let tour"
          class="material"
          [matTooltip]="tour.material"
          matTooltipClass="remarks-tooltip"
          matTooltipPosition="above"
        >{{ tour.material }}</td>
      </ng-container>
      <ng-container matColumnDef="internalNote">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.internalNote' | translate }}</th>
        <td mat-cell *matCellDef="let tour" class="material">{{ tour.internalNote }}</td>
      </ng-container>
      <ng-container matColumnDef="vao">
        <th mat-header-cell *matHeaderCellDef class="vao">{{ 'core.vao' | translate }}</th>
        <td mat-cell *matCellDef="let tour" class="vao">
          <app-tour-item-vao [tour]="tour"></app-tour-item-vao>
        </td>
      </ng-container>
      <ng-container matColumnDef="drivers">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.drivers' | translate }}</th>
        <td mat-cell *matCellDef="let tour">
          <app-tour-item-drivers [tour]="tour"></app-tour-item-drivers>
        </td>
      </ng-container>
      <ng-container matColumnDef="vehicles">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.vehicles' | translate }}</th>
        <td mat-cell *matCellDef="let tour">
          @for (team of tour.teams; track team) {
            <div class="vehicle-data">
              @if (team.vehicle) {
                {{ team.vehicle.licensePlate }}
              }
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="appointmentClass">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.appointmentClass' | translate }}</th>
        <td mat-cell *matCellDef="let tour">{{ tour.appointment.class | appointmentClassAsync }}</td>
      </ng-container>
      <ng-container matColumnDef="manager">
        <th mat-header-cell mat-sort-header="tour.manager.shortHand" *matHeaderCellDef>{{ 'core.manager' | translate }}</th>
        <td mat-cell *matCellDef="let tour" [matTooltip]="tour.manager.firstName + ' ' + tour.manager.lastName"  matTooltipPosition="above">
          {{ tour.manager.shortHand }}
        </td>
      </ng-container>
      <ng-container matColumnDef="planDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.planDate' | translate }}</th>
        <td mat-cell *matCellDef="let tour">{{ tour.appointment.planDate | date: 'shortDate' }}</td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.time' | translate }}</th>
        <td mat-cell *matCellDef="let tour">{{ tour.appointment.startTime }}</td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell mat-sort-header="date" *matHeaderCellDef>{{ 'core.date' | translate }}</th>
        <td mat-cell *matCellDef="let tour">{{ tour.appointment.date | date : 'shortDate' }}</td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef class="state">
          <mat-button-toggle-group multiple hideMultipleSelectionIndicator [value]="stateFilterValues" (change)="onStateFilterChange($event.value)">
            @for (tourState of tourStates.slice(0, -1); track tourState) {
              <mat-button-toggle [value]="tourState.name">
                <mat-icon [svgIcon]="tourState.svgIcon">{{tourState.matIcon}}</mat-icon>
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </th>
        <td mat-cell *matCellDef="let tour">
          <app-tour-item-progress [tour]="tour"></app-tour-item-progress>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let tour">
          <mat-menu #menu="matMenu">
            <app-tour-item-menu [tour]="tour"></app-tour-item-menu>
          </mat-menu>

          <button mat-icon-button [matMenuTriggerFor]="menu" [class.bubble]="!tour.printed" (click)="$event.stopPropagation()">
            <mat-icon class="material-icons more-vert">more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="checkbox-header">
          @if (mode !== viewMode.MonthOverview) {
            <mat-checkbox
              color="primary"
              (change)="$event ? toggleMasterSelection() : null"
              [checked]="selectedTours.hasValue() && areAllToursSelected"
              [indeterminate]="selectedTours.hasValue() && !areAllToursSelected"
            ></mat-checkbox>
          }
        </th>
        <td mat-cell *matCellDef="let tour" class="checkbox-body">
          @if (mode !== viewMode.MonthOverview) {
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? selectedTours.toggle(tour) : null"
              [checked]="selectedTours.isSelected(tour)"
              [disabled]="!tour.allowPostpone"
            ></mat-checkbox>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr [ngClass]="['linked-row', row.state, (row.internalNote != '' ? 'has-internal-comment': '')]"
        mat-row *matRowDef="let row; columns: tableColumns;"
        (click)="onRowClick(row)"
      ></tr>
    </table>
    @if (toursTable.dataSource && toursTable.dataSource.length == 0 ) {
      <app-no-result-message fxFlex="grow"></app-no-result-message>
    }
  </div>

  @if (mode !== viewMode.MonthOverview) {
    <div class="tour-actions" fxFlexAlign="end" fxLayout="column">
      <button
        mat-button
        *ngxPermissionsOnly="['ROLE_USER']"
        fxFlexAlign="end"
        [disabled]="!selectedTours.hasValue()"
        (click)="postponeTours()"
        class="postpone-tour-btn"
        >
        <mat-icon class="material-icons">subdirectory_arrow_right</mat-icon>
        {{ 'tours.actions.shift' | translate }}
      </button>
    </div>
  }
</div>
